export default __webpack_public_path__ + "static/media/hang-ten.0d36fe25.png";